import React from "react";
import { ImageProps } from "./types";
import { Box } from "@mui/material";
import "./styles.scss";

interface CustomImageProps extends ImageProps {
  className?: string;
}

const classNameBase = "scd-image";

export default function CustomImage({
  src,
  alt,
  className,
}: CustomImageProps): React.JSX.Element {
  return (
    <Box className={`${classNameBase}`}>
      <img
        className={`${classNameBase}-img ${className}`}
        src={src}
        alt={alt}
      />
    </Box>
  );
}
